var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"wt-scanning-eye",class:{ '-visible': _vm.visible },style:({ position: _vm.position })},[_c('div',{staticClass:"-eye"})])}
var staticRenderFns = []

export { render, staticRenderFns }